import UpdateKhasara from "../components/configuration/khasara/UpdateKhasara";

const UpdateKhasar = () => {
    return (
        <UpdateKhasara />
    )
}       
export default UpdateKhasar;
